import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
//import { Branch } from 'projects/sepidz-web-framework/src/lib/models';
import { SaleMethod } from "./sale-method.model";
import { ItemCategory } from "../../catalog/model/item-category.model";

export class SaleMethodBranchModel extends EntityBase {
  public IsActive: boolean;
  public ApplyService: boolean;
  public ApplyTax: boolean;
  public ApplyTaxForService: boolean;
  public IsBarCodeInvoice?: boolean;
  public PreprationTimeIsActive?: boolean;
  public PreprationTimeRequired?: boolean;
  public HasDeposit?: boolean;
  public ApplyTaxForShippingCost: boolean;
  public DeliveryCustomerPrintTimeId: number;
  public DeliveryCustomerPrintTimeTitle: string;
  public DeliveryCustomerPrintTimeCode: number;
  public NumberOfGuestsIsRequired: boolean;
  public IncludeFreeItemDependency: boolean;
  public IncludeItemDependency: boolean;
  public MaximumTimeForStay: number;
  public TableIsRequired: boolean;
  public HasKeyboardOrder: boolean;
  public HasOnlineRezerv: boolean;
  public HasHappyHour: boolean;
  public ItemCountDisplay: boolean;
  public ShowDescInvKitchen: boolean;
  public ShowDescInvCustomer: boolean;
  public FreeService?: boolean;
  public FreeShipping?: boolean;
  public HappyHourStart?: Date;
  public HappyHourEnd?: Date;
  public HappyHourFromDate?: Date;
  public HappyHourToDate?: Date;
  public Discount?: number;
  public IsDiscountPercent: boolean;
  public DaysOfWeek: string | string[];
  public WaiterIsRequired: boolean;
  public SaleMethodId: number;
  public SaleMethod: SaleMethod;
  public SaleMethodTitle: string;
  public ApplyTaxForPackingPrice?: boolean;
  public ApplyPackingPrice: boolean;
  public HasSnap: boolean;
  public AutoApplySnap: boolean;
  public InPerson: boolean;
  public HasDelino: boolean;
  public HaspickupOrderOnline: boolean;
  public FirstNumberingInDate: number;

  // public BranchId: number;
  // public Branch: Branch[];
  public IsChangeTheSalesMethod: boolean;
  public IsSalonFastAccess: boolean;
  public IsDriverAssignmentFastAccess: boolean;
  public IsCustomreFastAccess: boolean;
  public IsWaiterFastAccess: boolean;
  public IsPagerFastAccess: boolean;
  public IsClubFastAccess: boolean;
  public IsPaymentLink: boolean;
  public HasDelinoOfflineFactor: boolean;
  public ShowSalonName: boolean;
  public HasNecessaryMobile: boolean;
  public ShowCustomerInfo: boolean;
  public ShowWaiterName: boolean;
  public ShowNumberOfGuests: boolean;
  public SaleMethodNatureTitle: string;
  public SaleMethodNatureCode: number;
  public Code: number;
  public HasFactorLink: boolean;
  public HasPaymentLink: boolean;
  public AutomaticLinks: boolean;
  public HasPaymentLinkForNewCustomer: boolean;
  public PrintForOnlineOrder: boolean;
  public PrintForOnlineOrderForNewCustomer: boolean;

  public ItemCategories: SaleMethodBranchItemCategory[];
  public PaymentMethods: SaleMethodBranchPaymentMethod[];
  public SalePriceTypes: SaleMethodBranchSalePriceType[];
  public Salons: SaleMethodBranchSalon[];
  public CustomerCategories: SaleMethodBranchCustomerCategory[];
  public PrintTemplates: SaleMethodBranchPrintTemplate[];
  public PrintTemplatesClear: SaleMethodBranchPrintTemplate[];
  public Users: SaleMethodBranchUser[];
  public ItemSaleSubLedgerId?: number;
  public ShippingCostSubLedgerId?: number;
  public CourierShippingCostSubLedgerId?: number;
  public ServiceCostSubLedgerId?: number;
  public DiscountSubLedgerId?: number;
  public RoundingAmountSubLedgerId?: number;
  public HasNecessaryName: boolean;
  public UseMobileInValidation: boolean;
  public Branches: number[];
  public AllBranches: number[];
  public PaymentId: number;
  public DetailLedgerId: number;
  public DetailLedgerTitle: string;
  public DetailLedgerCode: number;
  public InvVoucherId: number;
  public InvWareHouseId: number;
  public InvDepositWareHouseId: number;
  public InvDepositVoucherKindId: number;
  public BranchId: number;
  public TaxApplyIsChanged: boolean;
  public hasBirthdayDate: boolean;
  public hasMarriageDate: boolean;
  constructor() {
    super();
    this.ApplyTax = false;
    this.hasBirthdayDate = false;
    this.hasMarriageDate = false;
    this.ApplyTaxForService = false;
    this.ApplyTaxForShippingCost = false;
    this.ApplyService = false;
    this.ItemCategories = [];
    this.IsActive = false;
    this.IsCustomreFastAccess = false;
    this.IsDriverAssignmentFastAccess = false;
    this.IsChangeTheSalesMethod = false;
    this.IsPagerFastAccess = false;
    this.IsClubFastAccess = false;
    this.IsSalonFastAccess = false;
    this.IsWaiterFastAccess = false;
    this.ShowSalonName = false;
    this.HasNecessaryMobile = false;
    this.ShowCustomerInfo = false;
    this.ShowNumberOfGuests = false;
    this.ShowWaiterName = false;
    this.HasDelino = false;
    this.HasSnap = false;
    this.HasHappyHour = false;
    this.HasNecessaryName = false;
    this.UseMobileInValidation = false;
    this.HasKeyboardOrder = false;
    this.SaleMethodTitle = "";
    this.WaiterIsRequired = false;
    this.HasFactorLink = false;
    this.HasPaymentLink = false;
    this.AutomaticLinks = false;
    this.HasPaymentLinkForNewCustomer = false;
    this.Branches = [];
    this.IsPaymentLink = false;
    this.PrintForOnlineOrder = false;
    this.PrintForOnlineOrderForNewCustomer = false;
    this.DetailLedgerId = null;
  }
}

export class SaleMethodBranchItemCategory extends EntityBase {
  public Selected: boolean;
  public Category: ItemCategory;
  public CategoryId: number;
  public CategoryTitle: string;
  public SaleMethodBranchId: number;
  public IsDefault: boolean;
}

export class SaleMethodBranchPaymentMethod extends EntityBase {
  public Selected: boolean;
  public PaymentMethodId: number;
  public PaymentMethodTitle: string;
  public SaleMethodBranchId: number;
  public IsDefault: boolean;
}

export class SaleMethodBranchSalePriceType extends EntityBase {
  public Selected: boolean;
  public SalePriceTypeId: number;
  public SalePriceTypeTitle: string;
  public SaleMethodBranchId: number;
  public IsDefault: boolean;
}

export class SaleMethodBranchSalon extends EntityBase {
  public Selected: boolean;
  public SalonId: number;
  public SalonTitle: string;
  public SaleMethodBranchId: number;
}

export class SaleMethodBranchCustomerCategory extends EntityBase {
  public Selected: boolean;
  public CategoryId: number;
  public CategoryTitle: string;
  public SaleMethodBranchId: number;
}

export class SaleMethodBranchPrintTemplate extends EntityBase {
  public Selected: boolean;
  public PrintTemplateId: number;
  public PrintTemplateTitle: string;
  public SaleMethodBranchId: number;
  public IsDefault: boolean;
}

export class SaleMethodBranchUser extends EntityBase {
  public Selected: boolean;
  public UserId: number;
  public UserName: string;
  public InvoiceDisplayTypeId: number;
  public InvoiceDisplayTypeTitle: string;
  public DisplayedInvoiceStatusId: number;
  public DisplayedInvoiceStatusTitle: number;
  public SalonId: number;
  public SaleMethodBranchId: number;
}
export class SaleMethodBranches extends EntityBase {
  public Selected: boolean;
  public BranchId: number;
  public IsActive: boolean;
  public BranchTitle: string;
}
export enum SaleMethodNature {
  Restaurant = 1,
  FastFood = 2,
  Delivery = 3,
}

export enum DeliveryCustomerPrintTime {
  PreparationPrint = 1,
  Assign = 2,
}
export class BranchList {
  Id: number;
  Title: string;
  IsActive: boolean;
}
